import { Action } from '@ngrx/store';
import { ProjectDto } from '@admin/models/project-dto';
import { ProjectUserReportDto } from '@app/generated/model';

export enum ProjectActionTypes {
  LoadProjects = '[Projects] Load',
  LoadProjectsSuccess = '[Projects] Load Success',
  FilterProjects = '[Projects] Filter',
  AddProject = '[Project - Add] Add',
  AddProjectSuccess = '[Project - Add] Success',
  LoadProject = '[Project - Edit] Load',
  LoadProjectSuccess = '[Project - Edit] Load Success',
  UpdateProject = '[Project - Edit] Update',
  UpdateProjectSuccess = '[Project - Edit] Update Success',
  LoadProjectUserReport = '[Statistics] Load Project User Report',
  LoadProjectUserReportSuccess = '[Statistics] Load Project User Report Success',
  FilterStatistics = '[Statistics] Filter',
}

export class LoadProjects implements Action {
  readonly type = ProjectActionTypes.LoadProjects;
}

export class LoadProjectsSuccess implements Action {
  readonly type = ProjectActionTypes.LoadProjectsSuccess;
  constructor(public projects: ProjectDto[]) {}
}

export class FilterProjects implements Action {
  readonly type = ProjectActionTypes.FilterProjects;
  constructor(public filter: string) {}
}

export class AddProject implements Action {
  readonly type = ProjectActionTypes.AddProject;
  constructor(public project: ProjectDto) {}
}

export class AddProjectSuccess implements Action {
  readonly type = ProjectActionTypes.AddProjectSuccess;
}

export class LoadProject implements Action {
  readonly type = ProjectActionTypes.LoadProject;
  constructor(public projectId: string) {}
}

export class LoadProjectSuccess implements Action {
  readonly type = ProjectActionTypes.LoadProjectSuccess;
  constructor(public project: ProjectDto) {}
}

export class UpdateProject implements Action {
  readonly type = ProjectActionTypes.UpdateProject;
  constructor(public project: ProjectDto) {}
}

export class UpdateProjectSuccess implements Action {
  readonly type = ProjectActionTypes.UpdateProjectSuccess;
  constructor(public project: ProjectDto) {}
}

export class LoadProjectUserReport implements Action {
  readonly type = ProjectActionTypes.LoadProjectUserReport;
}

export class LoadProjectUserReportSuccess implements Action {
  readonly type = ProjectActionTypes.LoadProjectUserReportSuccess;
  constructor(public report: ProjectUserReportDto[]) {}
}

export class FilterStatistics implements Action {
  readonly type = ProjectActionTypes.FilterStatistics;
  constructor(public filter: string) {}
}

export type ProjectActions =
  | LoadProjects
  | LoadProjectsSuccess
  | FilterProjects
  | AddProject
  | AddProjectSuccess
  | LoadProject
  | LoadProjectSuccess
  | UpdateProject
  | UpdateProjectSuccess
  | LoadProjectUserReport
  | LoadProjectUserReportSuccess
  | FilterStatistics;
